export const backend_string_2_date = (a: string) => new Date(a);

export const date_2_textfield_string = (a: Date) =>
  a ? a.getFullYear() + '-' + String(a.getMonth() + 1).padStart(2, '0') + '-' + String(a.getDate()).padStart(2, '0') : '';

export const textfield_string_2_date = (a: string) => new Date(a);
